import { getMessageFromErrorResponse, isBaseError } from '@/api/v4/base-fetch';

export const isNoActiveSubscriptionError = (error: unknown) => {
  if (isBaseError(error)) {
    const message = getMessageFromErrorResponse(error);
    return message === 'No active subscription';
  }

  return false;
};
